import React from "react";
import assign from "lodash/assign";
import { RaisedButton } from "material-ui";
import { Navigation, Link } from "react-router";

import BaseOverlay from "./base.jsx";
import Checkout from "../partials/checkout.jsx";
import InjectedTenantHTML from "../partials/injected-tenant-html.jsx";

import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../../stores/OrderStore";
import PersonStore from "../../stores/PersonStore";
import OrderActions from "../../actions/OrderActions";
import CouponActions from "../../actions/CouponActions";
import PassSubscriptionStore from "../../stores/PassSubscriptionStore";
import PassSubscriptionActions from "../../actions/PassSubscriptionActions";

export default statics(
  {
    willTransitionTo({ location }, replace, callback) {
      OrderActions.newOrderFlow();
      OrderActions.updateCurrentOrder({
        subitems: [
          {
            pass_subscription: location.query.subscription
          }
        ]
      });

      if (location.query.subscription) {
        PassSubscriptionActions.fetchOne(location.query.subscription);
      }
      CouponActions.reset();

      callback();
    }
  },

  @connectToStores
  class BuyCreditsOverlay extends React.Component {
    constructor(props) {
      super(props);
      this.cancel = this.cancel.bind(this);
    }

    static getStores() {
      return [OrderStore, PersonStore, PassSubscriptionStore];
    }

    static get contextTypes() {
      return {
        router: React.PropTypes.object.isRequired,
        appSettings: React.PropTypes.object.isRequired,
        tenant: React.PropTypes.object.isRequired
      };
    }

    static getPropsFromStores() {
      var state = OrderStore.getState();
      state.getOrderById = OrderStore.getOrderById;
      state.isLoggedIn = PersonStore.getState().isLoggedIn;
      state.person = PersonStore.getState().details;
      state.getPassSubscriptionById =
        PassSubscriptionStore.getPassSubscriptionById;
      state.passSubscriptions = PassSubscriptionStore.getState().passSubscriptions;
      return state;
    }

    cancel() {
      if (!(this.props.orderInProgress || this.props.orderSuccess)) {
        if (
          this.props.location.state &&
          this.props.location.state.fromMainListing
        ) {
          this.context.router.goBack();
        } else {
          this.context.router.push(`/subscriptions`);
        }
      }
    }

    submit() {
      OrderActions.submitOrder();
    }

    componentDidMount() {
      this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(newProps) {
      if (
        !newProps.location.query.subscription &&
        Object.keys(newProps.passSubscriptions).length
      ) {
        this.context.router.replace(
          `/subscriptions/renew?subscription=${
            Object.keys(newProps.passSubscriptions)[0]
          }`
        );
      } else if (
        !newProps.orderData.subitems.length ||
        !newProps.orderData.subitems[0].pass_subscription
      ) {
        OrderActions.updateCurrentOrder.defer({
          subitems: [
            {
              pass_subscription: newProps.location.query.subscription
            }
          ]
        });
      }
    }

    render() {
      let subscription = this.props.getPassSubscriptionById(
        this.props.location.query.subscription
      );
      if (!subscription) {
        return null;
      }

      return (
        <BaseOverlay onRequestClose={this.cancel}>
          <Checkout
            orderInProgress={this.props.orderInProgress}
            orderSuccess={this.props.orderSuccess}
            orderErrorMessage={this.props.orderErrorMessage}
            orderData={this.props.orderData}
            updateCurrentOrder={OrderActions.updateCurrentOrder}
            completedOrder={this.props.getOrderById(
              this.props.completedOrderId
            )}
            person={this.props.person}
            isLoggedIn={this.props.isLoggedIn}
            item={{
              name: `${subscription.quantity}x ${subscription.pass_bucket.name}`,
              subname: `Renewal (${subscription.pass_bucket.recurrence_count} ${subscription.pass_bucket.recurrence_interval})`,
              quantity: subscription.quantity,
              price:
                subscription.pass_bucket.recurrence_renewal_price ||
                subscription.pass_bucket.price,
              originalPrice: subscription.pass_bucket.recurrence_renewal_price
                ? subscription.pass_bucket.price
                : undefined
            }}
            fixedQuantity={true}
            buyLabel={"Renew"}
            actionVerb={"renew"}
            cancel={this.cancel}
            submit={this.submit}
          />
        </BaseOverlay>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/components/overlays/renew-subscription.jsx